import React from 'react';
import Image from '../../../components/AppImage';

const HeroSection = ({ language }) => {
  const content = {
    en: {
      title: "Connecting Africa\'s Finest Coffee to the World",
      subtitle: "WGIH - Your Trusted Partner in African Green Coffee Bean Trading"
    },
    zh: {
      title: "连接非洲最优质的咖啡与世界",
      subtitle: "WGIH - 您值得信赖的非洲生咖啡豆贸易伙伴"
    }
  };

  return (
    <div className="relative h-[400px] md:h-[500px] lg:h-[600px] overflow-hidden">
      <Image
        src="https://images.unsplash.com/photo-1722962883757-4ca3c1c9df56"
        alt="Aerial view of lush green African coffee plantation with workers harvesting ripe red coffee cherries under bright sunlight"
        className="w-full h-full object-cover" />

      <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/40" />
      <div className="absolute inset-0 flex items-center justify-center px-4">
        <div className="text-center max-w-4xl">
          <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-heading font-bold text-white mb-4 md:mb-6">
            {content?.[language]?.title}
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl text-white/90 font-medium">
            {content?.[language]?.subtitle}
          </p>
        </div>
      </div>
    </div>);

};

export default HeroSection;